









































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import CalendarHeader from './CalendarHeader.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { CalendarType } from '@/components/calendar/types';

import { getTodayDate, formatMonthToHumanText, formatDayToHumanText } from '@/utils/date'

@Component({
    components: {
        CalendarHeader,
        BaseButton,
    },
})
export default class CalendarLayout extends Vue {
    @Model('update:date') date!: string
    @Prop({ default: '' }) readonly title!: string
    @Prop({ default: false, type: Boolean }) readonly disabledType!: boolean

    type = CalendarType.Month;

    get isDay() {
        return this.type === CalendarType.Day
    }

    get humanDate() {
        if (this.type === CalendarType.Day) {
            return formatDayToHumanText(this.date);
        }

        return formatMonthToHumanText(this.date);
    }

    public setDayView() {
        this.type = CalendarType.Day;
    }

    resetDate() {
        const today = getTodayDate();

        this.$emit('update:date', today);
    }

    goBackDate() {
        this.$emit('date:back')
    }

    goNextDate() {
        this.$emit('date:next')
    }
}
